import { DestinacaoReservaModule } from './destinacao-reserva/destinacao-reserva.module';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { AreaRestritaSharedModule } from '../shared/area-restitra.shared.module';
import { CnpjPipe } from '../shared/pipe/cnpj-pipe';
import { CpfPipe } from '../shared/pipe/cpf-pipe';
import { MatriculaPipe } from '../shared/pipe/matricula.pipe';
import { MesPipe } from '../shared/pipe/mes.pipe';
import { MesesPipe } from '../shared/pipe/meses.pipe';
import { DocumentosService } from '../shared/services/documentos.service';
import { PessoaService } from '../shared/services/pessoa.service';
import { UtilService } from '../shared/util/util.service';
import { ContrachequeModule } from './contracheque/contraceque.module';
import { DeclaracaoRendimentoEmpFinModule } from './declaracao-rendimento-emp-fin/declaracao-rendimento-emp-fin.module';
import { DeclaracaoRendimentoModule } from './declaracao-rendimento/declaracao-rendimento.module';
import { IrFracaoPatrimonialModule } from './ir-fracao-patrimonial/ir-fracao-patrimonial.module';
import { RegulamentoComponent } from './regulamento/regulamento.component';
import { FinanceiroRoutingModule } from './router/financeiro.router';
import { SefModule } from './sef/sef.module';
import { FinanceiroService } from './service/financeiro.service';


@NgModule({
    imports: [
        CommonModule,
        AreaRestritaSharedModule,
        FinanceiroRoutingModule,
        ContrachequeModule,
        IrFracaoPatrimonialModule,
        DeclaracaoRendimentoModule,
        DeclaracaoRendimentoEmpFinModule,
        DestinacaoReservaModule,
        SefModule
    ],
    declarations: [
        RegulamentoComponent
    ],
    providers: [
        FinanceiroService,
        DecimalPipe,
        CnpjPipe,
        CpfPipe,
        MatriculaPipe,
        MesPipe,
        MesesPipe,
        DatePipe,
        PessoaService,
        DocumentosService,
        UtilService
    ]
})
export class FinanceiroModule {
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/financeiro.module.ts